<template>
  <div style="width: 100%; height: 100%" :id="lang">
    <boxTips
      v-show="isInternetExplorer10"
      @closeVersionTip="closeVersionTip"
    />
    <!-- 容器整体的部局 -->
    <div
      class="preview-box"
      :class="{hasInternetExplorer10: isInternetExplorer10}"
    >
      <!--header-->
      <div
        v-if="!isFullScreen"
        class="preview-box-header"
      >
        <div class="title-section">
          <svg class="icon-img icon-wrapper">
            <use :xlink:href="`#${getFileIcon()}`" />
          </svg>
          <bs-rename
            :file-data="fileData"
            @rename="rename"
            @finish="finish"
          />
          <div
            v-if="!renaming"
            class="tail-dec"
          >
            <div
              v-show="fileData.isvirus"
              class="virus-icon"
            >
              {{ $t('病毒') }}
            </div>
            <svg
              v-show="fileData.has_docs_lock"
              class="favorite-icon"
            >
              <use xlink:href="#iconLock" />
            </svg>
          </div>
        </div>
        <div
          id="btngroup"
          class="button-section"
        >
          <button
            v-if="btnDownloadRight"
            class="cp lv-bn lv-80 lv-rm-12 c-btn"
            @click="privateDownloadFile"
          >
            {{ $t('下载') }}
          </button>
        </div>
      </div>

      <!--body-->
      <div
        class="preview-box-body  clearfix"
        :style="{height: isFullScreen?'100%':'calc(100% - 50px)' }"
      >
        <!--preview body-->
        <div
          ref="previewBodyMain"
          :class="['preview-box-body-main common-transion']"
          :style="{width: '100%'}"
        >
          <div
            class="preview-main-iframe"
            :style="{height:isShowFoot?'calc(100% - 50px)':'100%'}"
          >
            <clientGuidPreview :file-info="clientToWebInfo" v-if="clientToWebVisible"/>
            <!-- 正常预览 -->
            <bs-switch
              v-else-if="!abnormalType"
              ref="bsswitch"
              :is-side-mode="isSideMode"
              @loadFail="loadFail"
              @loadingAction="loadingAction"
            />
            <!-- 异常预览提示 -->
            <bs-abnormal
              v-else
              :data="fileData"
              :type="abnormalType"
              :abnormal-data="abnormalData"
              @abnormal="abnormal"
            />
          </div>
          <!-- 底部操作栏 -->
          <div
            v-if="notSearch"
            v-show="isShowFoot"
            ref="previewMainFooter"
            :class="['preview-main-footer',
                     displayFooterScroller
                       ? 'preview-footer-float' : 'preview-footer-bottom']"
            @mousemove="footMouseMove"
          >
            <div class="preview-footer-bar common-transion">
              <!-- 左部区域 -->
              <div
                ref="sectionUp"
                class="section-up cp"
              >
                <span
                  :class="['previous-one', (hasPre? '':'inactive-mode')]"
                  @click="goto(-1)"
                >
                  <svg class="item-icon">
                    <use :xlink:href="hasPre? '#previousOne':'#disPreviousOne'" />
                  </svg>
                  <span class="previous-one-text">{{ $t('上一个') }}</span>

                </span>
              </div>
              <!-- 右部区域 -->
              <div
                ref="sectionDown"
                class="section-down"
              >
                <span
                  class="switch-list cp"
                  @click="toggleFooterScroller"
                >{{ displayFooterScroller? $t('收起列表') : $t('展开列表') }}</span>
                <bs-featureguide
                  v-model="guideArr[0].isShow"
                  :guide-key="guideArr[0].guideKey"
                  :is-auto-run="false"
                >
                  <up-menu
                    :list="typeList"
                    :only-up="true"
                    :is-right="true"
                    @click-item="changeVal"
                  >
                    <template slot="btname">
                      <span class="selector-type">{{ $t(listVal.type) }}</span>
                      <span class="selector-pos">
                        : {{ listVal.curNum }}/{{ listVal.totalNum }}
                      </span>
                    </template>
                  </up-menu>
                </bs-featureguide>
                <span
                  :class="['next-one cp', (hasNext? '':'inactive-mode')]"
                  @click="goto(1)"
                >
                  <span class="next-one-text">{{ $t('下一个') }}</span><svg class="item-icon">
                    <use :xlink:href="hasNext? '#nextOne':'#disNextOne'" />
                  </svg>
                </span>
              </div>
              <!-- 中间控制预览的操作区域 -->
              <div
                ref="sectionControl"
                class="section-control"
              >
                <bs-pdftoolBar
                  ref="pdftoolbar"
                  :data="fileData"
                  :doc-check="docCheck"
                  @presentationMode="presentationMode"
                />
              </div>
            </div>
            <!--file list scroller -->
            <div class="preview-footer-scroller-area">
              <bs-thumbnail
                :is-show="displayFooterScroller"
                :is-show-right="false"
                :step="fileListStep"
                :req-param="reqParam"
                :is-full-screen="isFullScreen"
                :selected-index="fileSelectedIndex"
                @load="onLoading"
                @deleteFileItem="deleteFileItem"
                @getSelectedData="getSelectedData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--confirm-->
    <co-confirm
      v-model="confirmData.isShow"
      :title="confirmData.title"
      :content="confirmData.content"
      :sure-btn="confirmData.sureBtn"
      :only-one="confirmData.onlyOne"
      :is-describe="confirmData.isDescribe"
      :describe="confirmData.describe"
      @sure="confirmData.cb()"
    />
    <!-- <co-confirm v-model="isConfirm" @sure="deletefile"></co-confirm> -->
    <co-dialog
      v-model="isDialog"
      :is-cancel-left="false"
    />

    <!--创建分享外联-->
    <bs-link-share
      ref="alinkshare"
      :current-data="this.fileData"
    />

    <bs-webtool ref="bswebtool" />
    <!-- 修改扩展名弹框 -->
    <co-toast
      v-model="showToast"
      :is-auto="true"
      :is-link="false"
      :toast-info="toastContent"
    />
    <!--审批组件-->
    <bs-approval
      ref="bsapproval"
      :other-data="apporvalData"
    />
    <co-toast
      v-model="showToastDelete"
      :is-auto="true"
      :is-link="true"
      :toast-link="$t('刷新')"
      :toast-info="deletedToastInfo"
      @go="deletedRefresh"
    />
  </div>
</template>
<script>

import bsThumbnail from 'components/business/thumbnail/index.vue'
import bsSwitch from 'components/business/switch/index.vue'
import bsRename from 'components/business/rename/index.vue'
import coMenu from 'components/common/menu/index.vue'
import bsPdftoolBar from 'components/business/pdftoolbar/index.vue'
import upMenu from 'components/business/upmenu/index.vue'
import coConfirm from 'components/common/confirm/index.vue'
import coDialog from 'components/common/dialog/index.vue'
import coTips from 'components/common/tips/index.vue'
import _$ from 'js/api/getdata'
import {
  typeIcon, getPreviewType, isClient, _DOC_PERVIEW_PATH, isExcel, exitFullscreen,
  isInternetExplorer10, getLanguage,
} from 'js/util/util'
import Cookie from 'js/lib/cookie'
import coToast from 'components/common/toast/index.vue'
import bsRpanel from 'components/business/rpanel/index.vue'
import bsWebtool from 'components/business/webtool/index.vue'
import bsFeatureguide from 'components/business/featureguide/index.vue'
import bsAbnormal from 'components/business/abnormal/index.vue'
import boxTips from 'components/page/box-tips.vue'
import { PREVIEW } from 'js/mixin/common'
import { RIGHT } from 'js/mixin/right'
// 外链分享部分
import bsLinkShare from 'components/business/linkshare/linkshare.vue'
import bsApproval from 'components/business/approval/request-approval.vue'
import clientGuidPreview from 'components/business/client-guide-preview/client-guide-preview.vue'
import { SHARE_TYPE } from 'components/business/linkshare/index'
import { bsFileDownLoad, fileEditCheck } from 'js/api/download/download'
import DocsEdit from 'js/api/privateApi/docsEdit'
import isExistPolicy from 'components/business/approval/request-approval'
import { doFileExistJob } from 'js/api/privateApi/private-apis'
import { localEdit, downloadFile } from '@filez/js-2-native'

export default {
  components: {
    bsThumbnail,
    bsSwitch,
    coMenu,
    bsPdftoolBar,
    upMenu,
    coConfirm,
    coDialog,
    bsRename,
    coToast,
    bsRpanel,
    bsFeatureguide,
    bsAbnormal,
    coTips,
    bsLinkShare,
    bsWebtool,
    bsApproval,
    boxTips,
    clientGuidPreview,
  },
  /**
     * 主要混入的函数
     * showFoot
     * footMouseMove
     * pushEsc
     * checkfull
     * loadFail
     */
  // right 权限相关的
  mixins: [PREVIEW, RIGHT],
  data() {
    return {
      lang: getLanguage(),
      isInternetExplorer10: isInternetExplorer10(),
      // 显示提示
      showToast: false,
      toastContent: {},
      show: true,
      // 文档类型选择
      typeList: [],
      // 全部类型
      allTypeList: [
        { name: '全部类型', key: 'all', type: -1 },
        { name: '图片', key: 'pic', type: 4 },
        { name: '文档', key: 'file', type: 1 },
        { name: '视频', key: 'video', type: 3 },
        { name: '音频', key: 'audio', type: 2 },
        { name: '其他', key: 'other', type: 0 },
      ],
      // 更多子菜单
      moreList: [
        { name: this.$t('预览'), key: 'preview' },
        { name: this.$t('本地编辑'), key: 'editNative' },
        { name: this.$t('本地编辑'), key: 'localEdit' },
        { name: this.$t('zDocs'), key: 'editOL' },
        { name: this.$t('共享管理'), key: 'auth' },
        { name: this.$t('收藏'), key: 'favorite' },
        { name: this.$t('取消收藏'), key: 'rmfavorite' },
        { name: this.$t('添加/编辑标签'), key: 'edittag' },
        { name: this.$t('历史版本'), key: 'history' },
        { name: this.$t('重命名'), key: 'rename' },
        { name: this.$t('移动/复制'), key: 'copymove' },
        { name: this.$t('锁定'), key: 'lock' },
        { name: this.$t('解锁'), key: 'unlock' },
        { name: this.$t('请求解锁'), key: 'reqUnlock' },
        { name: this.$t('删除'), key: 'delete' },
      ],
      displayRightPanel: true, // 默认展开右侧栏
      displayFooterScroller: false,
      displayTypeList: false,
      // 存放底部文件列表数据
      fileList: {
        currentPos: 0,
        content: [],
      },
      reqParam: {},
      // 是否有上一个
      hasPre: false,
      // 是否有下一个
      hasNext: false,
      // 记录上一个和下一
      fileListStep: 0,
      // 文件类型选择器
      listVal: {
        type: '全部类型',
        curNum: 0,
        totalNum: 0,
      },
      renaming: false, // 重命名编辑状态
      // 是否显示弹框
      isDialog: false, // dialog显隐
      isConfirm: false, // confirm显隐
      test: '',
      selectedData: {},
      // 最近访问图片的上报
      recentImages: [],
      // 是否是幻灯片模式
      isSideMode: false,
      confirmData: { // confirm弹框
        isShow: false,
        title: '提示',
        content: '',
        sureBtn: '确认',
        onlyOne: false,
        isDescribe: false,
      },
      abnormalType: '',
      abnormalData: { // 超限异常所需的max size
        maxSize: 0,
      },
      isShowFoot: true, // 是否显示底部操作栏
      shareLink: { // 外链部分
        showDialog: false, // 外链弹窗
        dialogTitle: this.$t('链接分享'), // 名称
        shareType: SHARE_TYPE.commonLink, // 外链分享类型
        otherData: {},
      },
      apporvalData: {}, // 审批外链的参数
      ajaxRequest: null,
      showToastDelete: false,
      deletedToastInfo: {
        info: this.$t('该文件/文件夹已被删除，无法进行操作'),
        tipsType: 'warn',
      },
      nearbyFile: {},
      fileSelectedIndex: -1,
      nearbyFileIndex: 0,
      previewList: [],
      notSearch: true,
      clientToWebVisible: false,
      clientToWebInfo: {},
    }
  },
  computed: {
    // 分享子菜单
    shareList() {
      const arr = [
        { name: this.$t('新建链接'), key: 'createNewLink', isShow: this.btnCommonLinkRight },
        // { name: this.$t('新建安全链接'), key: 'secureLink', isShow: this.btnSecurteLinkRight },
        // {name: this.$t('新建SmartShare'),key: 'smartShare'},
        // {name: this.$t('查看历史链接'),key: 'historyLink'}, //预览二期内容 现在怀线上保持一致
      ]
      const tmp = []
      arr.forEach((it) => {
        if (it.isShow) {
          tmp.push(it)
        }
      })
      return tmp || []
    },
    /**
       * 是否为客户端
       */
    isClient() {
      return isClient()
    },
    /**
       * 当前选中文件的信息
       */
    fileData() {
      return this.$store.state.curFileInfo
    },
    /**
       * 是否显示幻灯片模式
       */
    isShowSlideBtn() {
      return this.fileData && (/ppt|dps/i.test(this.fileData.mime_type)) && !this.isClient && !this.abnormalType
    },
    guideArr() {
      return this.$store.state.guideArr
    },
    requestStatus() {
      return this.$store.state.requeststatus
    },
  },
  watch: {
    /**
       * 切换换灯片模式的预览
       */
    isSideMode(n) {
      this.$store.commit('GET_IS_SIDEMODE', n)
      // this.$refs.bsswitch.init()
      this.changeWidth() // 切换slide mode时，计算顶部文件标题自适应宽度，英文英文下，btn宽度会变
    },
    requestStatus(val) {
      if (val.split('_')[0] === '404') {
        this.showToastDelete = true
        document.body.classList.add('request-not-found')
      } else {
        document.body.classList.remove('request-not-found')
      }
    },
  },
  async mounted() {
    const { from } = this.$route.params
    if (from === 'search') {
      this.notSearch = false
    }
    const me = this
    // 添加了回调函数，在init中病毒文件附加属性的判断，触发在页面绘制完成之后。
    this.init(true, this.changeWidth)
    window.onbeforeunload = function () {
      me.sendRecentImg()
    }
    window.addEventListener('message', (e) => {
      if (e && e.data === 'pdfLoadError') { // 监听到pdf报错信息，调用异常组件
        me.abnormalType = 'loadFail'
      }
    }, false)

    // 添加顶部文件标题尺寸互动监听
    window.addEventListener('resize', this.changeWidth)
  },
  created() {
    // 当多个新手引导时执行
    this.$store.dispatch('getGuide')
  },
  destroyed() {
    window.removeEventListener('resize', this.changeWidth)
  },
  methods: {
    closeVersionTip() {
      this.isInternetExplorer10 = false
    },
    /**
       * 幻灯片模式的切换
       */
    slideModeHandler() {
      this.isSideMode = !this.isSideMode
      this.$refs.bsswitch.init()
    },
    /**
       * iframe在加载过程中的一些操作
       * 目前ppt模式在loading中有本地打开（客户端）
       */
    loadingAction(type) {
      const cfg = {
        webLocalEdit: 'webLocalEdit', // 本地打开
      }
      if (cfg[type]) {
        this[cfg[type]]()
      }
    },
    /**
       * 创建外链
       */
    linkShare({ key }) {
      // 判断文件的数量,邮箱验证,odc
      this.$refs.alinkshare.create(key)
    },
    /*
               * web本地编辑打开
               */
    webLocalEdit() {
      this.$refs.bswebtool.init(this.fileData)
    },
    /**
       * 检查单文件的病毒
       */
    // async checkVirus(metadata) {
    //     let downloadUrl = singleDownloadUrl(metadata);
    //     let probeUrl = downloadUrl + '&probe=1'; // url中带probe，且不为空，是为了试探
    //     return _$.getData(probeUrl)
    // },
    /**
       * 客户端本地编辑
       * 后期掉hs封装好的函数然后
       */
    async clientLocalEdit() {
      // let me = this
      const metadata = this.fileData
      fileEditCheck(metadata, () => {
        // 校验完成后本地打开
        // 掉用客户端的方法
        localEdit({
          path: metadata.path,
          neid: metadata.neid,
        })
      })
    },
    /**
     * 私有：zDocs
     */
    privateDocsEdit() {
      const {
        neid, nsid, path,
        path_type: pathType,
        prefix_neid: prefixNeid, from,
      } = this.fileData
      doFileExistJob({
        path,
        path_type: pathType,
        neid,
        nsid,
        prefix_neid: prefixNeid,
        from,
      }).then(() => {
        isExistPolicy({ neid, nsid, path }, 'download').then(() => {
          new DocsEdit(this.fileData).docsEdit().catch((error) => {
            window.$toast.simpleShow((error.response
              && error.response.data
              && error.response.data.message)
              || error.message, 'warn')
          })
        }).catch(() => {
          this.$confirm.show({
            value: true,
            isShow: true,
            onlyOne: true,
            title: this.$t('提示'),
            content: this.$t('此目录因设置了审批规则,无法执行此操作'),
            sure: () => {
              this.$confirm.hide()
            },
          })
        })
      })
    },
    /**
    * 私有：下载
    */
    privateDownloadFile() {
      const { neid, nsid, path } = this.fileData
      // 查询是否有审批认证后进行下载
      isExistPolicy({ neid, nsid, path }, 'download').then(() => {
        this.downNewRevFile()
      }).catch((error) => {
        if (error.data) {
          if (error.data.length === 0) {
            window.$toast.simpleShow(this.$t('该审批规则没有审批者，请联系管理员'), 'warn')
          } else {
            this.apporvalData = {
              approvalType: 'download',
              approvers: error.data,
              neids: [neid],
              nsid,
              path,
            }
            this.$nextTick(() => {
              this.$refs.bsapproval.show()
            })
          }
        }
      })
    },
    /**
       * 下载最新版本的文件
       */
    downNewRevFile() {
      // 将当前metadata数据版本设置为空，必须未新对象防止污染旧对象
      const downData = { ...this.fileData }
      downData.rev = ''
      const downFile = { isDir: false, content: [downData] }
      if (this.isClient) {
        const params = {}
        downData.nsid = downData.nsid.toString()
        params.remotePaths = [downData]
        downloadFile(params)
      } else {
        bsFileDownLoad(downFile)
      }
    },
    /**
       * 调用新手引导接口
       */
    getGuide() { // 多个新手引导时
      _$.getData('getFeatureGuide', { bubbleType: 'preview' })
        .then((res) => {
          if (Object.keys(res.data.previewBubbleContent)
            && !Object.keys(res.data.previewBubbleContent).includes('upmenu')) { // upmenu不存在，证明预览页面首次打开
            this.guideArr[0].isShow = true
          }
        }, () => {
        })
    },
    /**
       * 新手引导关闭回调
       */
    afterGuide(val) {
      for (let i = 0; i < this.guideArr.length; i += 1) {
        if (this.guideArr[i].guideKey === val && (i !== this.guideArr.length - 1)) { // 判断关闭的新手引导，并且打开下一个
          this.guideArr[i + 1].isShow = true
          break
        } else {
          this.guideArr[i].isShow = false
        }
      }
    },
    /**
       * 检测预览是否超限
       */
    async checkFileLimit() {
      let data
      const { neid, nsid } = this.fileData
      const param = {
        neid,
        nsid,
      }
      try {
        data = await _$.getData('previewFileLimit', param)
      } catch (e) {
        data = {}
      }
      return data
    },
    /**
       * 获取文件extrameta信息，包括病毒，收藏，评论情况
       */
    async getExtraData() {
      const param = this.$route.params || {}
      const neid = +param.neid
      const extra = await _$.postData('extraMeta', { json: JSON.stringify([{ neid }]) })
      return extra
    },
    /**
       * 获取文件信息
       */
    async getMetaData() {

      const param = this.$route.params || {}
      const { neid, nsid } = param
      const senddata = { neid, nsid }
      let pathType = ''
      if (this.$route.query.other && JSON.parse(this.$route.query.other)) {
        pathType = JSON.parse(this.$route.query.other).pathType
        senddata.from = JSON.parse(this.$route.query.other).from
        senddata.prefix_neid = JSON.parse(this.$route.query.other).prefix_neid
      } else {
        pathType = 'recent'
      }
      const d = await _$.getDataAbort('getMetadata', senddata)
      if (this.ajaxRequest) {
        this.ajaxRequest.cancel()
      }
      this.ajaxRequest = d.source
      return d.action
    },
    /**
       * merge extradata 和 meta
       * P.S. 这两个数据结构不一致,请在控制台打出来，看一看
       */
    mergeData(data) {
      const result = {} // 最终合并的数据
      data.forEach((item) => {
        let decoratedData = {}
        if (Object.keys(item.data).length <= 1) {
          decoratedData = item.data.content[0] || {}
          Object.assign(result, decoratedData)
        } else {
          decoratedData = item.data || {}
          Object.assign(result, decoratedData)
        }
      })
      // console.log('merge data：',result)
      this.$store.commit('GET_CUR_FILE_INFO', result)
      return result
    },
    /**
       * upmenu  组件接收列表数据
       */
    changeVal(val) {
      this.initReqParam()
      this.reqParam.file_type = val.type
      this.listVal.type = val.name
    },
    /**
       * rename组件抛出事件，表示正在编辑状态，隐藏input框后面图标
       */
    rename(val) {
      this.renaming = val
    },
    /**
       * rename组件抛出事件，表示结束编辑状态，显示input框后面图标
       */
    finish(val) {
      this.renaming = val
    },
    /**
       * 更多操作
       */
    moreOperation(val) {
      // 删除，弹框
      if (val.key === 'delete') {
        this.isConfirm = true
      }
      if (val.key === 'reqUnlock') {
        this.isDialog = true
      }
    },
    /**
       * 删除弹框点击确认走删除功能
       */
    deletefile() {
      const info = JSON.stringify({ op_info: { neid: this.fileData.neid } })
      const data = {
        op: 'delete',
        ignore_share: false,
        auto_rename: false,
        info,
      }
      _$.postData('fileOp', data)
        .then(() => {
        })
    },
    /**
       * toggle 右侧栏
       */
    toggleRightPanel() {
      this.displayRightPanel = !this.displayRightPanel
      this.setWindowMedia()
      // 触发浏览器resize事件
      // document.querySelector(".preview-box-body-main").addEventListener("transitionend",function (e) {
      //     let myEvent = new Event('resize');
      //     window.dispatchEvent(myEvent);
      // })
    },
    /**
       * 获取文件的类型
       */
    getFileIcon() {
      const mineType = this.fileData.mime_type || ''
      const icon = typeIcon(mineType.split('.').pop())
      return icon
    },
    /**
       *显示当前文件历史版本记录
       */
    showRevision() {
      const {
        neid, nsid, path,
        path_type: pathType,
        prefix_neid: prefixNeid, from,
      } = this.fileData
      doFileExistJob({
        neid,
        nsid,
        path,
        from,
        path_type: pathType,
        prefix_neid: prefixNeid,
      }).then(() => {
        const query = { from: this.$route.params.from, ...this.$route.query }
        if (query.other) {
          const other = JSON.parse(query.other)
          query.other = JSON.stringify({
            ...other,
            neid,
            nsid,
          })
        }
        const { href } = this.$router.resolve({
          name: _DOC_PERVIEW_PATH.ver_preview,
          params: { neid, nsid },
          query,
        })
        // 跳转界面
        window.location.href = href
      })

    },
    /**
       * toggle 底部收缩框
       */
    toggleFooterScroller() {
      this.displayFooterScroller = !this.displayFooterScroller
      this.$store.commit('GET_FOOTER_ISHIDE', this.displayFooterScroller)
    },
    /**
       * 初始化文件列表的请求参数
       */
    initReqParam() {
      const { nsid, neid } = this.$route.params
      this.reqParam = {
        neid,
        nsid,
        path_type: 'ent',
        file_type: this.getListFileType(),
        other: this.getListOther(),
        S: Cookie.get('S'),
      }
      // 当前文件的类型
      const typeIndex = this.allTypeList
        .findIndex((element) => element.type === this.reqParam.file_type)
      this.listVal.type = this.allTypeList[typeIndex].name
    },
    /**
       * 获取可以选择的类型
       * @params {Array} typeListData 后端返回当前目录中的数据类型
       */
    getTypeList(typeListData) {
      this.typeList = []
      this.listVal.curNum = typeListData.curNum
      this.listVal.totalNum = typeListData.totalNum
      this.hasNext = this.listVal.curNum < this.listVal.totalNum
      this.hasPre = this.listVal.curNum > 1
      if (typeListData.typeList && typeListData.typeList.length) {
        this.allTypeList.forEach((item) => {
          typeListData.typeList.forEach((i) => {
            if (item.type === i) {
              this.typeList.push(item)
            }
          })
        })
      }
    },
    /**
       * 获取文件所属类型
       * 截取mine_type的第一位，代表着所属类型
       */
    getListFileType() {
      const metaData = this.$store.state.curFileInfo
      const type = metaData.mime_type || ''
      let typeIndex
      switch (type.split('/')[0]) {
        case 'doc':
          typeIndex = 1
          break
        case 'audio':
          typeIndex = 2
          break
        case 'video':
          typeIndex = 3
          break
        case 'image':
          typeIndex = 4
          break
        case 'other':
          typeIndex = 0
          break
        default:
          typeIndex = -1
          break
      }
      return typeIndex
    },
    /**
       * 设置文件列表所需的type参数
       */
    getListType() {
      const type = this.$route.params.from
      const typeMap = {
        ent: 'ent',
        self: 'self',
        myshare: 'share_out',
        shared: 'share_in',
        search: 'search',
        recent: 'recent',
        recent_pic: 'recent_pic', // recent图片集需要再改
        favorite: 'bookmark',
      }
      return typeMap[type]
    },
    /**
       * 设置文件列表所需的other参数
       */
    getListOther() {
      const other = this.$route.query && this.$route.query.other
      return other
    },
    /**
       * 获取文件列表的数据
       */
    onLoading({ reqParam, getRangeData, selectedItem }) {
      _$.getData('previewFileList', reqParam).then((res) => {
        const { filetypelist, fileindex, content } = res.data
        const curNum = JSON.stringify(selectedItem) === '{}' ? fileindex + 1 : selectedItem.fileindex + 1
        const typeListData = {
          typeList: filetypelist,
          curNum, // fileindex从0起
          totalNum: res.data.filecount,
        }
        this.selectedData = JSON.stringify(selectedItem) === '{}' ? content[fileindex] : selectedItem
        this.previewList = content
        this.getTypeList(typeListData)
        getRangeData(res, reqParam)
      }).catch((err) => {
        const error = err.response || {}
        getRangeData(error, reqParam)
        // 以下为假数据，以后需要删去
        // let res = {
        //     status: 200,
        //     data: fakeData,
        // }
        // let typeListData = {
        //     typeList: res.data.filetypelist,
        //     curNum: res.data.fileindex + 1, // fileindex从0起
        //     totalNum: res.data.filecount,
        // }
        // this.getTypeList(typeListData);
        // getRangeData(res);
      })
    },
    /**
       * 获取文件的title
       */
    getTitle(val) {
      if (!val) return
      const path = val.split('/')
      const len = path.length
      return path[len - 1]
    },
    /**
       * 上一页和下一页按钮
       */
    goto(step) {
      if (typeof +step === 'number') {
        if (+step < 0 && !this.hasPre) return
        if (+step > 0 && !this.hasNext) return
        this.fileListStep += step
      }
    },
    /**
       * 当前文件列表数据段里，选中的数据已删除
       */
    deleteFileItem(data) {
      // console.log('已删除', data.selectedData, data.fn);
      let confirm = {
        isShow: true,
        title: '提示',
        isDescribe: true,
        iconType: 'warn',
        onlyOne: true,
      }
      let confirmData = {}
      if (data.srcFolderExist) {
        confirmData = {
          content: '当前预览的文件夹已被删除',
          describe: '请返回列表查看',
          sureBtn: '返回列表',
        }
        confirm = Object.assign(confirm, confirmData)
        this.confirmData.cb = () => {
          // back to list
          this.goBack()
          // console.log('back to list')
        }
        this.confirmData = Object.assign(this.confirmData, confirm)
      } else {
        confirmData = {
          content: `${this.$t('当前预览的文件')}<span style="color: #637282;max-width: 178px;display: inline-block;height: 24px;line-height: 24px;overflow: hidden;vertical-align: text-top;text-overflow: ellipsis;white-space: nowrap;">${this.getTitle(data.selectedData.path)}</span>${this.$t('已被删除')}`,
          describe: '将为您重新获取列表文件',
          sureBtn: '刷新',
        }
        confirm = Object.assign(confirm, confirmData)
        this.confirmData.cb = () => {
          data.fn() // 删除后的跳转逻辑
        }
        this.confirmData = Object.assign(this.confirmData, confirm)
      }
    },
    /**
       * 获取底部文件列表的选中数据
       */
    getSelectedData(selectedData) {
      const getFileList = false // boolean值, 是否请求文件列表
      this.selectedData = selectedData
      if (this.$route.params.neid === selectedData.neid) return // meid相同时，不重复选中
      // 加载预览
      // this.$refs.bsswitch.startPreview(selectedData)
      this.listVal.curNum = selectedData.fileindex + 1 // fileindex从0起
      this.hasNext = this.listVal.curNum < selectedData.totalLen
      this.hasPre = this.listVal.curNum > 1
      // 更新路由
      const { neid, nsid } = this.selectedData
      const { query } = this.$route
      if (this.$route.params.from === 'favorite') {
        const { from, prefix_neid: prefixNeid, path_type: pathType } = selectedData
        const otherCurrent = {
          ...JSON.parse(query.other), from, prefix_neid: prefixNeid, path_type: pathType,
        }
        query.other = JSON.stringify(otherCurrent)
      }
      this.$router.push({
        name: 'approveBox',
        params: { from: this.$route.params.from, neid, nsid },
        query,
      })
      // 如果文件类型不支持全屏，那么做全屏操作
      if (this.isFullScreen && !this.isHasFullScreen(selectedData)) {
        exitFullscreen()
        this.isFullScreen = false
      }
      // 重置异常组件的显示
      this.abnormalType = ''
      // 重新设置顶部尺寸间距回调
      this.init(getFileList, this.changeWidth)
    },
    /*
    *  被删除后请求周边数据
    * */
    deletedRefresh() {
      const { fileindex } = this.selectedData
      const content = this.previewList
      // 如果是最后一个，请求前一个，否则请求后一个数据
      const nearbyFileIndex = fileindex === content.length - 1 ? fileindex - 1 : fileindex + 1
      if (nearbyFileIndex === -1) {
        this.goBack()
        return
      }
      this.nearbyFile = content[nearbyFileIndex]
      this.nearbyFileIndex = nearbyFileIndex
      // 更改展开列表的数据用于thumb组件去选中即将被请求的数据
      this.fileSelectedIndex = this.nearbyFileIndex
      this.getSelectedData(this.nearbyFile)
    },
    /**
       * 是否是图片
       */
    isImg(d) {
      return d.mime_type.indexOf('image') !== -1
    },
    /**
       * toggle 类型列表

    toggleTypeList() {
      this.displayTypeList = !this.displayTypeList
    },
    /**
       * 返回按钮
       */
    goBack() {
      let other = this.$route.query.other || '{}'
      other = JSON.parse(other)
      const {
        prefix_neid: prefixNeid, from: fileFrom, neid_dir: neidDir,
      } = other

      let parNeid = neidDir
      // 跳转界面
      let { from } = this.$route.params
      if (from === 'search') {
        from = other.path_type || ''
        if (from.includes('share')) {
          const shareMap = {
            share_in: 'shared',
            share_out: 'myshare',
            shared: 'shared',
            myshare: 'myshare',
          }
          from = shareMap[from]
        }
      }
      if (neidDir === '' && from.includes('share')) { // neidDir 为空表示共享的根目录
        parNeid = ''
        this.setBackRootPath(from)
      } else if (from.includes('share')) {
        parNeid = neidDir
      } else { // 非共享目录，parNeid 取prefixNeid、neidDir存在的值
        parNeid = prefixNeid || neidDir
      }
      if (from.includes('favorite')) { // 收藏目录的文件直接回到根目录
        parNeid = ''
        this.setBackRootPath(from)
      }
      // 共享和收到的共享需要携带prefix_neid 、 from
      let backHref = `/v/list/${from}${parNeid ? `/${parNeid}` : ''}`
      if (from.includes('share') && neidDir !== '') {
        backHref = `${backHref}/${prefixNeid}/${fileFrom}`
      }
      window.location.href = backHref
    },
    /*
      * 回到根目录，由于业务原因，userDirectory记录了用户企业和个人的访问目录，返回到根目录需要手动清除
      * 否则会出现bug
      * */
    setBackRootPath(patyType) {
      const userDirectory = JSON.parse(localStorage.getItem('userDirectory') || '[]')
      const userId = store.getters.uId
      const pathNeidMap = {
        ent: 'entNeid',
        self: 'selfNeid',
      }
      const pathNeid = pathNeidMap[patyType]
      if (!pathNeid) return
      userDirectory.forEach((item, index) => {
        if (item.userId === userId) {
          userDirectory[index][pathNeid] = ''
        }
      })
      localStorage.setItem('userDirectory', JSON.stringify(userDirectory))
      localStorage.setItem('currentPath', '/')
    },
    /**
       * 上报图片
       */
    sendRecentImg() {
      if (this.recentImages.length > 0) {
        const { nsid } = this.fileData
        const data = { fileType: 4, neids: this.recentImages, nsid }
        const { prefix_neid: prefixNeid, from } = JSON.parse(this.$route.query.other)
        if (this.getListType().includes('share')) {
          data.prefix_neid = prefixNeid
          data.from_uid = from
        }
        this.sendRecent(data)
      }
    },
    /**
       * 处理上报图片
       */
    handleRecentImg(neid) {
      if (this.recentImages.indexOf(neid) < 0) {
        this.recentImages.push(neid)
      }
    },
    /**
       * 最近访问的上报
       */
    sendRecent(d) {
      Object.assign(d, { arrayFormat: true })
      _$.postData('sendRecent', d)
    },
    /**
       * 初始化数据
       * 切换时，重置一些数据
       */
    initData() {
      this.isSideMode = false // 非幻灯片模式
    },
    guideToWeb(metaPromise) {
      if (isClient() && metaPromise && metaPromise.data) {
        const { mime_type: mineType, size, path } = metaPromise.data
        const iconType = typeIcon(mineType.split('.').pop())
        const toWebType = ['video', 'music']
        if (toWebType.includes(iconType)) {
          this.clientToWebVisible = true
          this.clientToWebInfo = {
            iconType,
            filename: path.split('/').pop(),
            size,
          }
        } else {
          this.clientToWebVisible = false
        }
      }
    },
    /**
       * 初始化预览信息
       * 请求文件信息如果有错出报错页面
       * 如果没错校验是否为大文件
       * @param {Boolean} getFileList 是否请求文件列表
       * @param 事件完成后的回调函数
       */
    async init(getFileList = true, callback) {
      this.initData()
      // 获取文件信息
      let data = {}
      try {
        // data = await this.getMetaData()
        // 并发请求metadata和extrameta
        const metaPromise = this.getMetaData()
        const extraPromise = this.getExtraData()
        const promiseArr = [metaPromise, extraPromise]
        const result = await Promise.all(promiseArr)
        data = this.mergeData(result)
        metaPromise.then((metadata) => {
          this.guideToWeb(metadata)
        })
        // 事件回调函数
        document.body.classList.remove('request-not-found-load')
        if (typeof callback === 'function') callback()
      } catch (e) {
        // 如果是404 说明文件被删了
        const errCfg = {
          403: { type: 'noAccess' }, // 无权限
          404: { type: 'delete' }, // 被删除
          500: { type: 'loadFail' }, // 加载失败
        }
        // 处理错误异常
        const res = e.response
        const { state } = res.data
        this.abnormalType = errCfg[state].type
        this.displayRightPanel = false
        if (state === 404) {
          document.body.classList.add('request-not-found-load')
        }
        if (getFileList) { // 请求底部滚动列表
          this.initReqParam()
        }
        return
      }
      if (getFileList) {
        this.initReqParam()
      }
      // 查检预览文件是否超限
      const fileLimit = (await this.checkFileLimit()).data
      if (fileLimit && !fileLimit.checkSizeResult) {
        this.abnormalData.maxSize = fileLimit.previewSizeLimit
        this.abnormalType = 'oversize'
        return
      }
      if (this.$refs.bsswitch) {
        this.$refs.bsswitch.startPreview(data)
      }
      this.setWindowMedia()
      // 如果是图片，那么返回或者关闭按钮时上报
      const {
        neid,
      } = data
      if (this.isImg(data)) {
        this.handleRecentImg(neid)
      } else {
        // 如果是文件那么直接上报
        const { nsid } = this.$route.params
        const sendData = { fileType: 1, neids: [neid], nsid }
        const { prefix_neid: prefixNeid, from } = JSON.parse(this.$route.query.other)

        if (this.getListType().includes('share')) {
          sendData.prefix_neid = prefixNeid
          sendData.from_uid = from
        }
        this.sendRecent(sendData)
      }
    },
    /**
       * 页面的媒体查询
       */
    setWindowMedia() {
      let isPdf = false
      const pdfRotateExist = document.querySelector('.section-control-doc .section-rotate-area')
      if (this.fileData && this.fileData.mime_type) {
        isPdf = typeIcon(this.fileData.mime_type.split('.').pop()) === 'pdf'
      } else if (pdfRotateExist) {
        isPdf = true
      }
      if (!isPdf && this.displayRightPanel) {
        this.$refs.previewBodyMain.classList.remove('screenPdf')
        this.$refs.previewBodyMain.classList.add('screenFile')
      } else if (isPdf && this.displayRightPanel) {
        this.$refs.previewBodyMain.classList.remove('screenFile')
        this.$refs.previewBodyMain.classList.add('screenPdf')
      } else {
        this.$refs.previewBodyMain.classList.remove('screenFile')
        this.$refs.previewBodyMain.classList.remove('screenPdf')
      }
    },
    /**
       * 判断是否有全屏的按钮
       */
    isHasFullScreen(d) {
      const metaData = d || this.fileData
      if (!metaData.neid) {
        return false
      }
      const type = getPreviewType(metaData)
      // 如果是非pdf和图片的那么没有全屏按钮
      if ((type === 'doc' && metaData.mime_type.indexOf('.xls') === -1) || type === 'image') {
        return true
      }
      return false
    },
    /**
       * 校验doc档预览
       * 超过文件限制，或者幻灯片模式是否要预览
       */
    docCheck() {
      if (!this.fileData) {
        return false
      }
      return !isExcel(this.fileData.mime_type) && !this.isSideMode && !this.abnormalType
    },
    /**
       * 计算tips的位置
       */
    AfterTipCreate() {
      // console.log(el,'23333333333333')
      // this.$nextTick(() => {
      //     console.log(el.$refs.popper.style.top)
      //     el.$refs.popper.style.top = `${0}px`
      //     console.log(el.$refs.popper.style.top)

      // })
    },
    /**
       * 异常函数的操作事件
       */
    abnormal(key) {
      const cfg = {
        back: 'goBack',
        download: isClient() ? 'clientLocalEdit' : 'privateDownloadFile', // download
        refresh: 'refreshPreview', // refresh
      }
      if (cfg[key]) {
        this[cfg[key]]()
      }
    },
    /**
       * failed to load, click 'refresh' to load it again
       */
    refreshPreview() {
      this.abnormalType = '' // 重置异常组件的显示
      this.init(false)
    },
    /** 计算顶部文件标题自适应宽度 */
    changeWidth() {
      // 注释掉了，按照固定最大450px宽度来，待优化title部分
      // let btngroup = document.getElementById('btngroup')     //获取按钮组件
      // if (btngroup) {
      //     this.$nextTick(() => {
      //         if (document.querySelector('.tail-dec')) {
      //             //返回箭头尺寸和ui间距12的和
      //             document.querySelector('.title-section').style.width = btngroup.getBoundingClientRect().left - 64 + 'px'
      //             //获取图标的宽度,2为边框属性
      //             let tailWidth = document.querySelector('.tail-dec').clientWidth + 2
      //             //104在64基础上面在加上文件图标测尺寸
      //             document.querySelector('.rename-section').style.maxWidth = btngroup.getBoundingClientRect().left - (104 + tailWidth) + 'px'
      //         }
      //     })
      // }
    },
  },
}
</script>
<style lang="less">
.preview-box-body {
  //媒体查询 start, 这里没有加scoped，是因为打包后深度选择器没起作用
  .screenPdf {
    @media screen and (max-width: 1110px) {
      .section-control {
        .section-zoom-area {
          .zoom-out {
            margin: 0 10px 0 0;
          }

          .zoom-num {
            display: none;
          }
        }

        .section-rotate-area {
          .rotate-ccw {
            margin: 0 10px 0 0;
          }
        }
      }

      .section-down {
        margin-left: 0px !important;

        .switch-list {
          margin-right: 0px !important;
        }
      }
    }
  }

  //媒体查询 end
}
</style>

<style lang="less" scoped>
@import '~less/button.less';
@import '~less/box.less';

.request-not-found-load {
  .title-section,
  .button-section,
  .section-control{
    display: none!important;
  }

}
.common-transion {
  transition: width 0.4s ease;
}

.preview-box {
  &.hasInternetExplorer10{
    height: calc(100% - 44px);
    .preview-box-header{
      box-shadow: none;
    }
  }
  .preview-box-header {
    .title-section {
      .virus-icon {
        line-height: 16px;
        border: 1px solid #FF1B43;
        font-size: 12px;
        color: #FF1B43;
        padding: 0 4px 0 4px;
        margin-left: 8px;
        border-radius: 2px;
        display: inline-block;
      }

      .tail-dec {
        .favorite-icon {
          height: 16px;
          width: 16px;
          vertical-align: middle;
          margin-left: 8px;
        }
      }
    }

    .button-section {
      .img-icon-wrapper {
        width: 32px;
        height: 32px;
      }

      .img-icon-wrapper-logo {
        width: 20px;
        height: 20px;
        vertical-align: text-bottom;
      }

      .item-icon-more {
        width: 15px;
        height: 14px;
      }
    }
  }

  .preview-box-body {
    //媒体查询 start
    @media screen and (max-width: 1100px) {
      .section-control {
        float: right;
        width: auto;
      }
    }

    .screenPdf {
      @media screen and (max-width: 1570px) {
        .section-control {
          float: right;
          width: auto;
        }
      }
      @media screen and (max-width: 1280px) {
        .section-up {
          .previous-one {
            min-width: 32px;
            padding: 0px;

            .previous-one-text {
              display: none;
            }
          }
        }

        .section-down {
          .drop-down-component {
            .selector-pos {
              display: none;
            }
          }

          .next-one {
            min-width: 32px;
            padding: 0px;

            .next-one-text {
              display: none;
            }
          }
        }
      }
    }

    .screenFile {
      @media screen and (max-width: 1180px) {
        .section-up {
          .previous-one {
            min-width: 32px;
            padding: 0px;

            .previous-one-text {
              display: none;
            }
          }
        }

        .section-down {
          .next-one {
            min-width: 32px;
            padding: 0px;

            .next-one-text {
              display: none;
            }
          }
        }
      }
      @media screen and (max-width: 1070px) {
        .section-down {
          .drop-down-component {
            .selector-pos {
              display: none;
            }
          }
        }
      }
    }

    //媒体查询 end
    .preview-box-body-main {
      .preview-main-footer {
        transition: height 0.4s ease;
        z-index: 50; // 底部footer的z-index，高于中间预览区域，但小于header，右侧栏 etc.
        .preview-footer-bar {
          width: 100%;
          height: 50px;
          display: block;
          background-color: #F6F7FA;
          box-shadow: -4px 0 6px 0 rgba(0, 0, 0, 0.15);
          position: relative;
          z-index: 1; // 底部列表的内部层级
        }

        .preview-footer-scroller-area {
          height: 144px;
          background: #fff;
        }

        .item-icon {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
      }

      .preview-footer-float {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 194px;
      }

      .preview-footer-bottom {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 50px;
      }
    }

    .inactive-mode { //不可操作状态
      color: #929CA9;

      &:hover {
        background: none !important;
        color: #929CA9;
      }

      &:active {
        background: none !important;
        color: #929CA9;
      }
    }

    .section-up {
      float: left;
      line-height: 50px;
      margin-left: 20px;
      font-size: 14px;
      color: #1B2733;

      .previous-one {
        line-height: 32px;
        display: inline-block;
        min-width: 80px;
        box-sizing: border-box;
        padding: 0 13px 0 0;
        text-align: center;
        border-radius: 2px;

        .previous-one-text {
          text-align: left;
          display: inline-block;
        }
      }

      .previous-one:hover {
        background: #E8EBEF;
      }

      .previous-one:active {
        background: #C1C7CD;
      }
    }

    .section-down {
      float: right;
      line-height: 50px;
      margin-right: 20px;
      margin-left: 12px;
      color: #1B2733;
      font-size: 14px;

      .switch-list {
        width: 72px;
        line-height: 32px;
        display: inline-block;
        text-align: center;
        border-radius: 2px;
        margin-right: 12px;
      }

      .drop-down-component {
        .selector-pos {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
          max-width: 80px;
          vertical-align: middle;
        }
      }

      .next-one {
        line-height: 32px;
        display: inline-block;
        min-width: 80px;
        padding: 0 0 0 13px;
        box-sizing: border-box;
        text-align: center;
        border-radius: 2px;

        .next-one-text {
          text-align: right;
          display: inline-block;
        }
      }

      .switch-list:hover, .type-selector:hover, .next-one:hover {
        background: #E8EBEF;
      }

      .switch-list:active, .type-selector:active, .next-one:active {
        background: #C1C7CD;
      }
    }
  }
}
</style>
